export const SITE_METADATA = {
  title: 'Co-Founder & CEO, Zakool AI | Author',
  description:
    'Anu Singh is the Co-Founder and CEO of Zakool AI, building AI sales infrastructure for real estate developers and brokerages across the UAE and India.',
  author: 'Anu Singh',
  siteUrl: 'https://www.anusingh.ai',
  email: 'anu@zakool.ai',
  linkedIn: 'https://www.linkedin.com/in/anu-singh-46b6082ba/',
  twitter: '@anujainsingh',
  logo: 'https://www.anusingh.ai/logo-mark.png',
  favicon: 'https://www.anusingh.ai/favicon.ico'
};

export const NAV_LINKS = [
  { name: 'About', path: '/#about', internal: true },
  { name: 'Zakool AI', path: '/#zakool', internal: true },
  { name: 'Publications', path: '/#perspectives', internal: true },
  { name: 'Journey', path: '/#journey', internal: true },
  { name: 'Insights', path: '/insights', internal: true },
  { name: 'Contact', path: '/#contact', internal: true }
];

export const PERSONAL_INFO = {
  name: 'Anu Singh',
  title: 'Co-Founder & CEO, Zakool AI | Author',
  tagline: 'AI | PropTech | Real Estate',
  currentLocation: 'UAE + India'
};

export const COMPANIES = {
  zakool: {
    name: 'Zakool AI',
    description: 'AI sales infrastructure for real estate developers and brokerages',
    focus: 'Connected buyer journeys across web, WhatsApp and voice'
  },
  rayTravels: {
    name: 'Ray Travels India',
    description: 'Travel and customer experience business',
    founded: '2014'
  }
};

export const EDUCATION = [
  { degree: 'Data Science & AI', institution: 'IIM' },
  { degree: 'MBA', institution: 'Symbiosis' },
  { degree: 'Bachelor in Journalism & Mass Communication', institution: 'Indraprastha University' }
];

export const SOCIAL_LINKS = {
  linkedin: 'https://www.linkedin.com/in/anu-singh-46b6082ba/',
  twitter: 'https://x.com/anujainsingh',
  github: ''
};

export const CONTACT_SUBJECTS = [
  'General Inquiry',
  'Partnership Opportunity',
  'Investment Discussion',
  'Product Demo',
  'Speaking Engagement',
  'Other'
];

export const SEO_KEYWORDS = [
  'Anu Singh',
  'Zakool AI',
  'PropTech',
  'real estate AI',
  'AI sales infrastructure',
  'real estate sales technology',
  'buyer journey',
  'buyer intelligence',
  'real estate developers',
  'real estate brokerages',
  'WhatsApp AI',
  'voice AI'
];
